import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const gratinDauphinois: Recipe = {
  slug: 'gratin-dauphinois',
  title: 'Gratin dauphinois',
  category: 'salé',
  description: 'Un gratin fondant de pommes de terre, préparé au lait, à la crème et à la muscade.',
  image: image('gratin-dauphinois'),
  tags: ['pommes de terre', 'four', 'crème'],
  meta: [
    { label: 'Préparation', value: '30 min' },
    { label: 'Cuisson', value: '50 min à 1 h' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('pommes-de-terre', 'pommes de terre', '1,5 kg de pommes de terre', {
        amount: 1.5,
        unit: 'kg',
        shoppingKey: 'pommes de terre',
      }),
      ingredient('ail', 'ail semoule', 'Quelques grammes d’ail semoule'),
      ingredient('creme', 'crème', '30 cl de crème', { amount: 30, unit: 'cl', shoppingKey: 'crème' }),
      ingredient('assaisonnement', 'sel, poivre et muscade', 'Sel, poivre et muscade'),
      ingredient('beurre', 'beurre', '100 g de beurre', { amount: 100, unit: 'g', shoppingKey: 'beurre' }),
      ingredient('lait', 'lait', '1 L de lait', { amount: 1000, unit: 'mL', shoppingKey: 'lait' }),
    ]),
  ],
  steps: [
    'Dans cet ordre : éplucher, laver puis couper les pommes de terre en rondelles fines.',
    'Mettre dans une casserole le lait, l’ail, le sel, le poivre et la muscade. Porter à ébullition et y plonger les pommes de terre. Laisser cuire 10 à 15 minutes, puis égoutter grossièrement.',
    'Placer les pommes de terre dans un plat beurré, disposer des petites noix de beurre puis recouvrir de crème.',
    'Cuire à 210 °C pendant 50 minutes à 1 heure.',
  ],
}
